<!-- Row: Filter Row -->
<div class="tile-progress bg-white text-left col-lg-12" style="margin-bottom: 20px;">
    <div class="row">

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display:flex;">Select Account
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <ng-select #filterAccount name="accounts" placeholder="Select account" bindLabel="accountName" bindValue="accountId"
                [items]="accounts" [clearable]="true" [searchable]="true" [(ngModel)]="accountId"
                (change)="getScreeningCentersByAccountID()">
            </ng-select>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="showScreeningCenterDropdown">
            <label style="display: flex;">Select Screening Center
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <div class="controls">
                <ng-multiselect-dropdown [disabled]="accountId == null" [settings]="dropdownSettings"
                    [data]="screeningCenterList" name="screeningCenters" [(ngModel)]="screeningCenterToBind"
                    (onSelect)="onSelectScreeningCenter($event,'ADD')"
                    (onDeSelect)="onSelectScreeningCenter($event,'REMOVE')"
                    (onSelectAll)="onSelectScreeningCenter($event,'ADD_ALL')"
                    (onDeSelectAll)="onSelectScreeningCenter($event,'REMOVE_ALL')">
                </ng-multiselect-dropdown>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="showOperatorDropdown">
            <label style="display: flex;">Select Operator
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <div class="controls">
                <ng-multiselect-dropdown [disabled]="orgIds == null" [settings]="dropdownSettings" [data]="operators"
                    name="operators" [(ngModel)]="operatorToBind" (onSelect)="onSelectOperator($event,'ADD')"
                    (onDeSelect)="onSelectOperator($event,'REMOVE')" (onSelectAll)="onSelectOperator($event,'ADD_ALL')"
                    (onDeSelectAll)="onSelectOperator($event,'REMOVE_ALL')">
                </ng-multiselect-dropdown>
            </div>
        </div>

    </div>

    <div class="row" style="margin-top: 15px;">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display: flex;">Select Date Range
                <span class="mandatory-symbol">&nbsp;*</span>
            </label>
            <ngx-mat-drp #dateRangePicker [options]="calendarOptions"
                (selectedDateRangeChanged)="updateDateRange($event)">
            </ngx-mat-drp>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display: flex;">
                <span>Start Time</span>
                <span
                    *ngIf="selectedStartHour !== null && selectedStartMinute !== null">&nbsp;-&nbsp;{{selectedStartHour}}:{{selectedStartMinute}}&nbsp;{{selectedStarMeridiem}}</span>
            </label>
            <div style="display: flex;">
                <ng-select [items]="hours" name="fromHour" bindLabel="itemName" [(ngModel)]="selectedStartHour"
                    [searchable]="true" [clearable]="false" bindValue="id" placeholder="Hours" style="width: 24%;"
                    (change)="onTimeChange('startHour')" [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
                <ng-select [items]="minutes" name="fromMinute" bindLabel="itemName" [(ngModel)]="selectedStartMinute"
                    [searchable]="true" [clearable]="false" bindValue="id" placeholder="Minutes" style="width: 28%;"
                    (change)="onTimeChange('startMinute')" [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
                <ng-select [items]="meridiem" name="frommeridiem" bindLabel="itemName"
                    [(ngModel)]="selectedStarMeridiem" [searchable]="true" [clearable]="false" bindValue="id"
                    placeholder="AM" (change)="onTimeChange('startMinute')" style="width: 19%;"
                    [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
            <label style="display: flex;">
                <span>End Time</span>
                <span
                    *ngIf="selectedEndHour !== null && selectedEndMinute !== null">&nbsp;-&nbsp;{{selectedEndHour}}:{{selectedEndMinute}}&nbsp;{{selectedEndMeridiem}}</span>
            </label>
            <div style="display: flex;">
                <ng-select [items]="hours" name="fromHour" bindLabel="itemName" [(ngModel)]="selectedEndHour"
                    [searchable]="true" [clearable]="false" bindValue="id" placeholder="Hours" style="width: 24%;"
                    (change)="onTimeChange('endHour')" [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
                <ng-select [items]="minutes" name="fromMinute" bindLabel="itemName" [(ngModel)]="selectedEndMinute"
                    [searchable]="true" [clearable]="false" bindValue="id" placeholder="Minutes" style="width: 28%;"
                    (change)="onTimeChange('endMinute')" [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
                <ng-select [items]="meridiem" name="frommeridiem" bindLabel="itemName" [(ngModel)]="selectedEndMeridiem"
                    [searchable]="true" [clearable]="false" bindValue="id" placeholder="AM" style="width: 19%;"
                    (change)="onTimeChange('startMinute')" [disabled]="operatorIds == null || operatorIds.length == 0">
                </ng-select>
            </div>
        </div>

    </div>

    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-12" style="margin-top: 28px; padding-right: 0px; text-align: end;">
        <button type="button" class="btn btn-info btn-raised" style="width: 200px;" (click)="getAppointmentDetails(0, 'start')"
            [disabled]="operatorIds == null || operatorIds.length == 0">
            <span tooltip="Get appointment details" style="color: #fff; text-align: center;">Get Appointments</span>
        </button>
    </div>

</div>
<!-- Row: Filter Row ENDS-->

<div *ngIf="showAppointmentDetails">

    <div class="col-sm-2 col-lg-3 col-sm-2 col-xs-2" style="display: flex;">
        <input type="checkbox" style="width: 20px;" (change)="CheckAllOptions()" class="checkbox"
            [(ngModel)]="isChecked" [disabled]="appointments==null || appointments.length==0 || isSelectAll || disableSelectAll">
        <span style="margin-top: 10px; margin-left: 10px;">Select All (Current page)</span>
    </div>

    <div *ngIf="totalAppointmentsCount > 10" class="col-sm-2 col-lg-3 col-sm-2 col-xs-2" style="display: flex;">
        <input type="checkbox" style="width: 20px;" (change)="CheckAllPagesOptions()" class="checkbox"
            [(ngModel)]="isSelectAll" [disabled]="appointments==null || appointments.length==0">
        <span style="margin-top: 10px; margin-left: 10px;">Select All (All pages)</span>
    </div>

    <div style="text-align:end; margin-bottom:10px">
        <!-- <span class="select-text" *ngIf="cancelAppointmentCount > 0" style="float: left;
            margin-top: 1%;
            margin-left: 6%;">
            <span *ngIf="cancelAppointmentCount !== totalAppointmentsCount">
                <span *ngIf="isChecked">All <b>{{ cancelAppointmentCount }}</b> appointments on this page are
                    selected.</span>
                <span *ngIf="!isChecked && cancelAppointmentCount > 1"><b>{{ cancelAppointmentCount }}</b> appointments on this page are
                    selected. </span>
                <span *ngIf="!isChecked && cancelAppointmentCount == 1"><b>{{ cancelAppointmentCount }}</b> appointment on this page is
                    selected. </span>

                <span class="select-over-all" (click)="CheckAllOptions('overall')">Select all <b>{{
                        totalAppointmentsCount }}</b> appointments</span>
            </span>
            <span *ngIf="cancelAppointmentCount == totalAppointmentsCount">All <b>{{ totalAppointmentsCount }}</b>
                appointments are selected.</span>
        </span> -->
        <span style="font-weight: bold; padding-top: 10px; float: left;"
            [ngStyle]="{'visibility':cancelAppointmentCount > 0 ? 'visible' : 'hidden'}">{{cancelAppointmentCount}}
            <span *ngIf="cancelAppointmentCount === 1">appointment selected</span>
            <span *ngIf="cancelAppointmentCount > 1">appointments selected</span>
        </span>

        <button type="button" (click)="sendNotificationModal(customNotifications)" class="btn btn-info btn-raised"
            [disabled]="!enableSendNotificationButton || operatorIds == null || operatorIds.length == 0" style="margin-right: 30px; width: 200px; background-color: orange;">
            <span tooltip="Click here to send notification(s)">
                <i class="fa fa-bell" style="margin-top:6px;color:#fff;"></i> Send Notifications</span>
        </button>
    </div>

    <div>
        <div class="content-body padding-top-20 padding-bottom-20">
            <div class="row">
                <p-table [value]="appointments" [paginator]="appointments!=null && appointments.length>10" [rows]="10"
                    #dt>
                    <ng-template pTemplate="header">
                        <tr style="height:50px;">
                            <th style="text-align: center;width: 6%; padding: 0;">Select
                            </th>
                            <th style="text-align: center;width: 5%;">#
                            </th>
                            <th style="width: 23%;" [pSortableColumn]="'mrn'">MRN
                                <p-sortIcon [field]="'mrn'"></p-sortIcon>
                            </th>
                            <th style="width: 22%;">Created
                            </th>
                            <th style="width: 22%;">Start Date & Time
                            </th>
                            <th style="width: 22%;">End Date & Time
                            </th>
                            <th style="width: 10%;">Status
                            </th>
                        </tr>
                        <!-- <tr *ngIf="appointments==null || appointments.length==0"
                            style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                            <td colspan="6">
                                <div style="padding: 5px;text-align: center;">
                                    No appointments found
                                </div>
                            </td>
                        </tr> -->
                        <tr style="font-family:Arial, FontAwesome;text-align: center;">
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">

                                <input class="primeng-table-search-field search-bar-true"
                                    placeholder="&#xf002;  Search MRN " pInputText type="text" [(ngModel)]="mrnInputText"
                                    (input)="searchByMRN($event.target.value)">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                            <td class="primeng-table-search">
                            </td>
                        </tr>
                        <tr *ngIf="appointments==null || appointments.length==0"
                            style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                            <td colspan="6">
                                <div style="padding: 5px;text-align: center;">
                                    No appointments found
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-appointments let-i="rowIndex">
                        <tr class="table-striped" style="height: 50px;">
                            <td style="text-align: -webkit-center;">
                                <input type="checkbox" style="width: 20px;" (change)="checkedValue(appointments)"
                                    [(ngModel)]="appointments.isChecked" class="checkbox"
                                    [value]="appointments.id" [disabled]="isSelectAll || appointments.isQueuedToSendNotification">
                            </td>
                            <td style="text-align: center;">{{ i + 1}}</td>
                            <td>{{appointments.mrn}} </td>
                            <td>{{appointments.created | date: 'dd-MMM-yyyy'}}
                                {{appointments.created | date: 'shortTime'}}
                            </td>
                            <td>{{appointments.tentativeStartTime | date: 'dd-MMM-yyyy'}}
                                {{appointments.tentativeStartTime | date: 'shortTime'}}
                            </td>
                            <td>{{appointments.tentativeEndTime | date: 'dd-MMM-yyyy'}}
                                {{appointments.tentativeEndTime | date: 'shortTime'}}
                            </td>
                            <td>{{(appointments.isQueuedToSendNotification ? "In Queue" : null)}}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr
                            *ngFor="let eventsList of appointments | paginate: { itemsPerPage: 10, currentPage: page,totalItems: totalAppointmentsCount };">
                        </tr>
                        <td colspan="6" class="text-center">
                            <pagination-controls style="margin-top: 10px;" (pageChange)="onTableDataChange($event)"
                                *ngIf="appointments!=null && appointments.length>0"></pagination-controls>
                        </td>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>


<ng-template #customNotifications>
    <div class="modal-header">
        <div style="display:flex; justify-content:space-between; width:100%">
            <h4 style="margin: 0px;">
                Send Custom Notification
                <!-- <i class="fa fa-phone fa-duotone" aria-hidden="true"></i> -->
            </h4>
            <h4 (click)="modalRef.hide()" style="cursor:pointer; margin: 0px;">
                <i class="fa fa-times" aria-hidden="true"></i>
            </h4>
        </div>
    </div>

    <div class="modal-body" style="padding-bottom: 10px; padding-top: 10px;">
        <div style="font-weight: bold; padding-bottom: 10px;text-align: center;">{{cancelAppointmentCount}}
            <span *ngIf="cancelAppointmentCount === 1">appointment selected</span>
            <span *ngIf="cancelAppointmentCount > 1">appointments selected</span>
        </div>

        <div>
            <label>Select Custom Template</label>
            <ng-select name="customNotificationDropdown" placeholder="Select custom template" bindLabel="templateKey"
                bindValue="id" [items]="customTemplateContents" [clearable]="true" [searchable]="true"
                (change)="getNotificationContent($event)">
            </ng-select>
        </div>

        <div style="margin-top: 10px;" *ngIf="showNotificationContent">
            <label style="border-bottom: 1px solid black;">Content:</label>
            <div style="white-space: pre-line">{{selectedTemplateContent}}</div>
        </div>
    </div>

    <div class="modal-footer" style="justify-content: center !important;">
        <div style="display: flex !important;justify-content: center !important;">
            <div>
                <button class="btn btn-sm btn-warning btn-80" [disabled]="templateKey == null"
                    style="background-color:#5d9cec; border:1px solid #5d9cec; color:white; border-radius:0px; width:150px;"
                    (click)="modalRef.hide();sendSelectedNotification()">Send</button>
            </div>
        </div>
    </div>
</ng-template>